@if (searchContainer.focus.curFocus) {
  <div class="search-focus-menu-panel dropdownIgnoreClicks"
       [ngClass]="{checked: searchContainer.focus.curFocus}"
  >
    <div class="search-focus-menu-panel__container">
      <a
        class="search-focus-menu-panel__close-focus-button"
        (click)="closeMenu()"
      >
        <mat-icon>
          navigate_before
        </mat-icon>

        <span>
          {{ 'TRANS__FOCUS__GO_BACK' | translate }}
        </span>
      </a>

      <div class="search-focus-menu-panel__top-section">
        <div class="search-focus-menu-panel__title">
          <span class="search-focus-menu-panel__title-text">
            <i class="icon-overview text-blue"></i>

            @if (!searchContainer.focus.curFocusId && !searchContainer.focus.curFocus.focus.name) {
              <span class="uppercase">
                {{ 'TRANS__FOCUS__INFO_SET_FOCUS_AS_NEW_SEARCH' | translate }}
              </span>
            }

            @if (searchContainer.focus.curFocus.focus.name) {
              <span class="uppercase">
                {{ '' | translate:{focusName: searchContainer.focus.curFocus.focus.name} }}
              </span>
            }
          </span>

          @if (searchContainer.focus.curFocusId) {
            <span class="search-focus-menu-panel__title-edit">
              <i
                class="icon-edit-alternative"
                (click)="editFocus(searchContainer.focus.curFocus)"
                (keydown)="null"
              ></i>
            </span>
          }
        </div>

        <div class="search-focus-menu-panel__info">
          @if (!searchContainer.focus.curFocusId) {
            <span>
              {{ 'TRANS__FOCUS__INFO_SET_FOCUS' | translate }}
            </span>
          }

          @if (searchContainer.focus.curFocus.focus.stored && (hasChanges() && !dialogOpen)) {
            <span>
              <span>
                {{ 'TRANS__FOCUS__INFO_FOCUS_CHANGED_TO' | translate:{focusName: searchContainer.focus.curFocus.focus.name} }}
              </span>
            </span>
          }

          @if (storeMessage) {
            <span>
              <span>
                {{ storeMessage | translate:{focusName: searchContainer.focus.curFocus.focus.name} }}
              </span>
            </span>
          }
        </div>

        @if (searchContainer.focus.curFocusId) {
          <div class="search-focus-menu-panel__top-section-button-group">
            <a
              class="search-focus-menu-panel__top-section-button bg-primary"
              (click)="deselectFocus()"
            >
              <span>
                {{'TRANS__FOCUS__BUTTON_LEAVE_FOCUS' | translate}}
              </span>
            </a>

            <div class="search-focus-menu-panel__top-section-button-group-separated">
              <a
                class="search-focus-menu-panel__top-section-button bg-primary"
                [ngClass]="{'disable-button bg-gray': !hasChanges() || dialogOpen ? 'disabled': undefined}"
                [attr.disabled]="!hasChanges() || dialogOpen ? 'disabled': undefined"
                (click)="storeFocusChanges()"
              >
                <span>
                  {{ 'TRANS__FOCUS__BUTTON_STORE_CHANGES' | translate }}
                </span>
              </a>

              <a
                class="search-focus-menu-panel__top-section-button bg-gray"
                (click)="setFocusAsNewSearch()"
              >
                <span>
                  {{ 'TRANS__FOCUS__BUTTON_STORE_AS_NEW_SEARCH' | translate }}
                </span>
              </a>
            </div>
          </div>
        }

        @if (!searchContainer.focus.curFocusId) {
          <div class="search-focus-menu-panel__top-section-button-no-focus">
            <a
              class="bg-primary"
              [ngClass]="{'no-stored-focuses': displayFocus.length === 0}"
              (click)="setFocusAsNewSearch()"
            >
              <span>
                {{ 'TRANS__FOCUS__BUTTON_STORE_AS_NEW_SEARCH' | translate }}
              </span>
            </a>
          </div>
        }
      </div>

      <div class="search-focus-menu-panel__get-focus">
        <a
          class="search-focus-menu-panel__get-focus-button"
          (click)="toggleSelectFocusPanel()"
        >
          <span>
            {{ 'TRANS__FOCUS__SEARCH_SELECT_FOCUSES' | translate }}
          </span>

          <mat-icon>
            {{showSelectFocusPanel ? 'expand_less' : 'expand_more'}}
          </mat-icon>
        </a>

        @if (showSelectFocusPanel) {
          <div class="search-focus-menu-panel__search">
            <label for="selectFocus">
              <span>
                {{ 'TRANS__FOCUS__SEARCH_AFTER_FOCUSES' | translate }}
              </span>
            </label>

            <div class="clearInputContainer">
              <input
                type="text"
                id="selectFocus"
                placeholder="&#xe62c;&nbsp;{{'TRANS__FOCUS__SEARCH_AFTER_FOCUSES__PLACEHOLDER' | translate}}"
                [(ngModel)]="searchQuery"
                (ngModelChange)="inputChange()"
                autocomplete="off"
              >

              @if (searchQuery) {
                <a
                  class="clearInputField"
                  (click)="clearSearchInput()"
                >
                  <mat-icon>
                    close
                  </mat-icon>
                </a>
              }
            </div>

            <span>
              {{ 'TRANS__FOCUS__SELECT_FOCUSES' | translate }}
            </span>

            <div class="search-focus-menu-panel__search-options-container">
              <ul class="search-focus-menu-panel__search-options">
                @for (fo of displayFocus; track $index) {
                  <li
                    [ngClass]="{'active': fo.focus.settingMenu}"
                    class="search-focus-menu-panel__search-option"
                  >
                    <span
                      class="search-focus-menu-panel__search-option-content"
                      [ngClass]="{'bold': fo.focus.settingMenu}"
                    >
                      <mat-radio-button
                        (click)="selectFocus(fo)"
                        (keydown)="null"
                        [checked]="fo.focus.marked"
                        class="gray-radio-button search-focus-menu-panel__radio-button"
                      >
                        <span
                          [innerHTML]="getFocusNameWeighedWordBreak(fo)"
                          class="search-focus-menu-panel__search-option-content-text"
                        ></span>

                        @if (fo.focus.isDefault) {
                          <span>
                            {{ 'TRANS__FOCUS__SELECT_FOCUSES__START_FOCUS' | translate }}
                          </span>
                        }
                      </mat-radio-button>

                      <span
                        class="search-focus-menu-panel__search-option-setting-button"
                        (click)="toggleSettingMenu(fo)"
                        (keydown)="null"
                      >
                        <mat-icon>
                          settings
                        </mat-icon>
                      </span>
                    </span>

                    @if (fo.focus.settingMenu) {
                      <span
                        class="search-focus-menu-panel__search-option-setting-menu"
                        [ngClass]="{'bold': fo.focus.settingMenu}"
                      >
                        <span
                          (click)="editFocus(fo)"
                          (keydown)="null"
                        >
                          {{ 'TRANS__FOCUS__SELECT_FOCUSES__EDIT' | translate}}
                        </span>

                        <span class="search-focus-menu-panel__search-option-setting-menu-line"></span>

                        <span
                          (click)="delete(fo)"
                          (keydown)="null"
                        >
                          {{ 'TRANS__FOCUS__SELECT_FOCUSES__DELETE' | translate }}
                        </span>
                    </span>
                    }
                  </li>
                }
              </ul>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}

@if (searchContainer.focus.curFocus) {
  <div
    class="transparent-overlay"
    (click)="closeMenu()"
    (keydown)="null"
  ></div>
}
